<template>
  <a-icon
    container-none
    :title="icon.tooltip"
    :icon="icon.icon + ' ' + 'fa-2x'"
    :variant="(icon.danger ? 'danger' : 'success')"
  />
</template>

<script>
  import { AIcon } from 'codefabrik-gui-vue'

  export default {
    name: "Icon",
    components: { AIcon },
    props: {
      icon: {
        type: Object,
        default: () => {}
      }
    },
  }
</script>

<style lang="scss" scoped>
</style>
